export default __webpack_public_path__ + "static/media/icon-chevron-left-blue.76db74c2.svg";